import bookingCollectionActions from './bookingCollectionActions';
import resourcesActions from './resourcesActions';
import alternativesActions from './alternativesActions';

export default {
  ...bookingCollectionActions,
  ...resourcesActions,
  ...alternativesActions
};
